module.exports = __webpack_public_path__ + "img/banner2.e7581a69.png";